import React from "react";
import { PeekButton, PeekClickAwayListener, PeekListItem, PeekListItemButton, PeekListItemText, PeekMenu, PeekPaper, } from "@piiqtechnologies/ui-components";
import { Plus as PlusIcon } from "@piiqtechnologies/svg-icons";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { useGoogleMapApi } from "@piiqtechnologies/ui-lib";
export const AdminActions = ({ onSelectNewAdd }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const intl = useIntl();
    useGoogleMapApi();
    const handleShowAdminActionsMenu = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const buttonOptions = [
        intl.formatMessage(messages.communityOption),
        intl.formatMessage(messages.userOption),
        intl.formatMessage(messages.organizationOption),
        intl.formatMessage(messages.magicButtonOption),
        intl.formatMessage(messages.betaFeatureOption),
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekButton, { size: "large", variant: "outlined", color: "info", startIcon: React.createElement(PlusIcon, null), onClick: handleShowAdminActionsMenu }, intl.formatMessage(messages.adminActionsButton)),
        React.createElement(PeekMenu, { sx: { mt: 0.5, zIndex: 999 }, anchorEl: anchorEl, open: open },
            React.createElement(PeekClickAwayListener, { onClickAway: handleShowAdminActionsMenu },
                React.createElement(PeekPaper, { sx: { boxShadow: "none !important", minWidth: "120px" } }, buttonOptions.map((label) => {
                    const labelId = `checkbox-list-label-${label}`;
                    return (React.createElement(PeekListItem, { key: label, disablePadding: true },
                        React.createElement(PeekListItemButton, { onClick: () => onSelectNewAdd(label), dense: true },
                            React.createElement(PeekListItemText, { id: labelId, primary: label, primaryTypographyProps: { variant: "body1" } }))));
                }))))));
};
export default AdminActions;
